import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import useModifiers from 'hooks/useModifiers';

export enum AnchorTabsHeaderModifier {
  SMALL_LINK = 'smallLink',
}
export interface AnchorTabsHeaderGroup {
  label: string;
  isActive: boolean;
}
export interface AnchorTabsHeaderProps {
  groups: AnchorTabsHeaderGroup[];
  showHeader: boolean;
  rightElement?: React.ReactElement;
  modifiers: AnchorTabsHeaderModifier[];
  handleTabNavigation(index: number): void;
}

function AnchorTabsHeader(props: AnchorTabsHeaderProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const tabsRef = React.useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const mods = useModifiers(props.modifiers);

  const handleTabNavigation = (index: number) => {
    setActiveIndex(index);
    props.handleTabNavigation(index);
  };

  return (
    <div>
      <div ref={tabsRef}>
        { props.showHeader && (
        <div className="ct_anchorTabs-tabs">
          { props.groups.map((group: AnchorTabsHeaderGroup, index: number) => (
            <div key={group.label} className="ct_anchorTabs-item">
              <div
                aria-hidden
                onClick={() => handleTabNavigation(index)}
                className={`ct_anchorTabs-link ${mods} ${index === activeIndex ? '_active' : ''} ${!group.isActive ? '_disabled' : ''}`}
              >
                {group.label}
              </div>
            </div>
          ))}
          { props.rightElement && (
            <div className="ct_anchorTabs-item _right">
                { props.rightElement }
            </div>
          )}
        </div>
        )}
      </div>
    </div>
  );
}

AnchorTabsHeader.defaultProps = { ...{} };

export default AnchorTabsHeader;
